// extracted by mini-css-extract-plugin
export default {"Container":"FooterInfo_Container__vMZPe","Badges":"FooterInfo_Badges__gE+dV"};